import {
  blockPathName,
  type BlockPath,
} from "../generated/storyblok/blockPaths.js";

/**
 * Returns a name (user facing title) for a given block path.
 */
export function getBlockPathName(blockPath: string) {
  const name = blockPathName[blockPath as unknown as BlockPath];

  /** Quick hack to make missing names look a bit better */
  if (!name) {
    return blockPath.replace("-", " ").replace("noan", "NOAN");
  }

  return name;
}
